import type { ModId } from '../sim/mods';

/** How each weapon mod is named on screen: in full when it is found, short in the HUD. */
export const MOD_TEXT: Readonly<Record<ModId, { name: string; short: string; does: string }>> = {
  spread: { name: 'SPREAD LASER', short: 'SPREAD', does: 'EVERY LASER IS THREE' },
  pierce: { name: 'PIERCING BEAM', short: 'PIERCE', does: 'LASERS GO THROUGH ENEMIES' },
  homing: { name: 'HOMING ROCKETS', short: 'HOMING', does: 'ROCKETS FIND THEIR TARGET' },
};
